import { render, staticRenderFns } from "./SaicPrecipitationData.vue?vue&type=template&id=6ae18217&scoped=true"
import script from "./SaicPrecipitationData.vue?vue&type=script&lang=js"
export * from "./SaicPrecipitationData.vue?vue&type=script&lang=js"
import style0 from "./SaicPrecipitationData.vue?vue&type=style&index=0&id=6ae18217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae18217",
  null
  
)

export default component.exports